
import ModuleController from "./ModuleController";
import Todo from "../models/todo";
import TodoItem from "../models/todo-item";
import { TodoSubject } from "../components/Subject";
import { EVENTS } from "../global/constants";
import { GeneralObserver } from "../components/Observer";
import userManager from '../components/user-manager';

export default class TodoController extends ModuleController {
    constructor(todo={}) {
        super();
        this.todo = todo;
        this.subject = new TodoSubject();
        this.expanded = true;

        if ( this.todo instanceof Todo ) { 
            this.expanded = !userManager.hasCollapsedItem(this.todo.getId());
        }

        this.bindFunctions();
    }

    bindFunctions() {
        this.setupChildObserver = this.setupChildObserver.bind(this);
        this.childReactFn = this.childReactFn.bind(this);
    }

    //
    // Create
    // 

    addNew(newData={}) {
        const item = new TodoItem(newData);
        item.animate = true;
        this.todo.addNewItem(item);
        this.subject.runReload();
    }

    // 
    // Read
    // 

    getTodo() {
        return this.todo;
    }

    getId() {
        return this.todo.getId();
    }

    getItems() {
        return this.todo.getItems();
    }

    getExpanded() {
        return this.expanded;
    }

    // 
    // Update
    // 

    setTodo(newTodo) {
        this.todo = new Todo(newTodo);
    }

    setExpanded(newValue=false) {
        this.expanded= newValue;
    }

    // Creates a new todo from editData
    // Runs reload on subject
    editTodo(editData={}) {
        this.todo = new Todo(editData);
        this.subject.runReload();
    }

    // Expand change handler
    // Saves state to userManager
    handleExpandChange() {
        const todoId = this.getId();

        if ( this.expanded ) {
            userManager.removeCollapsedItem(todoId);
        } else {
            userManager.addCollapsedItem(todoId);
        }
    }
    
    // 
    // Delete
    // 

    deleteToDoItem(id=-1) {
        if ( id !== -1 ) {
            this.todo.deleteItem(id);
            this.eventHappened(EVENTS.delete);

            return true;
        }
        return false;
    }

   
    // Toggles expand state by negating
    // Calls handleExpandChange
    toggleExpand() {
        this.expanded = !this.expanded;
        this.handleExpandChange();
    }

    eventHappened(eventType=EVENTS.reload)  {
        if ( this.subject ) { 
            this.subject.runEvent(eventType);
        }
    }

    // Adds child observer and calls childRectfn
    // To react to todoItem events
    setupChildObserver(childCtrl) {
        this.childObserver = new GeneralObserver(this.childReactFn);
        childCtrl.addObserver(this.childObserver);
    }

    childReactFn(event) {
        const newEvent = { name: 'childUpdate', value: event.value };
        this.subject.runEvent(newEvent);
        
    }
   
}